import { CERTA_API_URL } from 'config';
import { postWithResponse, get, put, del, putWithResponse } from './fetch';
import { User } from 'types/user';
import { ListRolesResponse } from 'types/api/users/list-roles-response';
import { ListUsersResponse } from 'types/api/users/list-users-response';
import { GetUserResponse } from 'types/api/users/get-user-response';
import { CreateUserRequest } from 'types/api/users/create-user-request';
import { UpdateUserRequest } from 'types/api/users/update-user-request';
import { CreateUserResponse } from 'types/api/users/create-user-response';
import { ResetPasswordRequest } from 'types/api/users/reset-password-request';
import * as tokenService from 'services/token-service';
import * as tenantService from 'services/tenant-service';
import { UpdateUserResponse } from 'types/api/users/update-user-response';

export async function listRoles(tenantId: string): Promise<ListRolesResponse> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  return await get<ListRolesResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users/roles`,
    token,
    tenantId,
    language
  );
}

export async function listUsers(tenantId: string): Promise<ListUsersResponse> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  return await get<ListUsersResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users`,
    token,
    tenantId,
    language
  );
}

export async function getUser(tenantId: string, userId: string): Promise<User> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  const response = await get<GetUserResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users/${userId}`,
    token,
    tenantId,
    language
  );
  return response.user;
}

export async function createUser(tenantId: string, user: User): Promise<CreateUserResponse> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  const request = {
    user
  } as CreateUserRequest;
  return await postWithResponse<CreateUserResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users`,
    request, 
    token,
    tenantId,
    language
  );
}

export async function updateUser(tenantId: string, userId: string, user: User): Promise<User> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  const url = `${CERTA_API_URL}/tenants/${tenantId}/users/${userId}`;
  var response = await putWithResponse<UpdateUserResponse>(url,
    {
      userId,
      user
    } as UpdateUserRequest,
    token,
    tenantId,
    language
  );
  return response.user;
}

export async function deleteUser(tenantId: string, userId: string): Promise<void> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  await del(
    `${CERTA_API_URL}/tenants/${tenantId}/users/${userId}`,
    token,
    tenantId,
    language
  );
}

export async function activateUser(tenantId: string, userId: string): Promise<User> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  var response = await putWithResponse<UpdateUserResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users/${userId}/activate`,
    {},
    token,
    tenantId,
    language
  );
  return response.user;
}

export async function deactivateUser(tenantId: string, userId: string): Promise<User> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const language = await tenantService.getLanguageCode();
  var response = await putWithResponse<UpdateUserResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/users/${userId}/deactivate`,
    {},
    token,
    tenantId,
    language
  );
  return response.user;
}

export async function resetPassword(tenantId: string, userEmail: string): Promise<void> {
  const language = await tenantService.getLanguageCode();
  await put(
    `${CERTA_API_URL}/tenants/${tenantId}/users/passwordreset`,
    {
      emailAddress: userEmail
    } as ResetPasswordRequest,
    undefined,
    tenantId,
    language
  );
}


// WEBPACK FOOTER //
// ./src/api/user-api.ts